/**
 * Makes scroll-reveal content visible when JavaScript is unavailable.
 *
 * The marketing pages hide content until it is revealed, by two mechanisms:
 *
 *  1. CSS, `[data-sreveal] { opacity: 0 }`, with a script adding `.is-visible`
 *     once the element scrolls into view.
 *  2. framer-motion, `initial={{ opacity: 0, y: 16 }}`, which server-renders as
 *     an inline `style="opacity:0"`.
 *
 * Either way, with scripting off nothing ever becomes visible, so the page
 * served a full document that rendered as a blank screen. This emits a
 * `<noscript>` stylesheet that forces the revealed end state. A rule in a
 * stylesheet marked `!important` outrides a non-important inline style, which is
 * what lets it defeat framer-motion's server-rendered opacity.
 *
 * It costs nothing when scripting is on: the browser never applies a
 * `<noscript>` stylesheet in that case, so the animations run untouched.
 *
 * Deliberately limited to opacity and transform. An earlier version also reset
 * clip-path and visibility, which would have exposed visually-hidden
 * screen-reader content such as the `.zmk-mobile-demo` card on the landing
 * page. No reveal in this codebase animates either property.
 */
export function NoScriptReveal() {
  return (
    <noscript>
      <style
        dangerouslySetInnerHTML={{
          __html: `
[data-sreveal],
[data-sline],
[style*="opacity"] {
  opacity: 1 !important;
  transform: none !important;
}
`,
        }}
      />
    </noscript>
  );
}
